import React from "react";

export function MapleLogo({ className = "", size = 34, light = false }) {
  return (
    <img
      src={light ? "/ccpm-mark-light.png" : "/ccpm-mark.png"}
      alt="CCPM maple leaf mark"
      style={{ height: size, width: "auto" }}
      className={className}
    />
  );
}

export function Wordmark({ light = false }) {
  return (
    <div className="flex items-center gap-3.5 select-none">
      <MapleLogo light={light} size={56} />
      <div className="leading-tight max-w-[180px] sm:max-w-none">
        <div className={`text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.18em] ${light ? "text-ccpm-olive-soft" : "text-ccpm-taupe"}`}>
          Canadian Council for
        </div>
        <div className={`font-serif text-lg sm:text-2xl leading-tight tracking-tight ${light ? "text-ccpm-ivory" : "text-ccpm-charcoal"}`}>
          Paramedical Micropigmentation
        </div>
      </div>
    </div>
  );
}
